import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { Suspense, lazy } from "react";

const MentalHealthAssessment = lazy(() => import("./MentalHealthAssessment"));

const MindfulnessPageLazy = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <MentalHealthAssessment />
    </Suspense>
  );
};

export default MindfulnessPageLazy;
